"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingCardGroup = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/domains/pricing/pricing-card");
/**
 * 비교할 요금제 카드 목록. 카드를 같은 너비의 열로 나란히 놓고, 목록 role과 간격을 소유한다.
 * 좁은 화면에서는 한 열로 쌓인다.
 */
let PricingCardGroup = class PricingCardGroup extends lit_1.LitElement {
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'list');
    }
    render() {
        return (0, lit_1.html) `
      <slot @slotchange=${this.handleSlotChange}></slot>
    `;
    }
    handleSlotChange() {
        this.items.forEach(item => item.setAttribute('role', 'listitem'));
    }
};
PricingCardGroup.styles = (0, lit_1.css) `
    :host {
      display: grid;
      width: 100%;
      grid-template-columns: repeat(auto-fit, minmax(min(100%, 16rem), 1fr));
      gap: var(--space-8);
    }
  `;
__decorate([
    (0, decorators_js_1.queryAssignedElements)({ flatten: true })
], PricingCardGroup.prototype, "items", void 0);
PricingCardGroup = __decorate([
    (0, decorators_js_1.customElement)('mm-pricing-card-group')
], PricingCardGroup);
exports.PricingCardGroup = PricingCardGroup;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJpY2luZy1jYXJkLWdyb3VwLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicHJpY2luZy1jYXJkLWdyb3VwLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBd0U7QUFFeEUscURBQWtEO0FBRWxEOzs7R0FHRztBQUVJLElBQU0sZ0JBQWdCLEdBQXRCLE1BQU0sZ0JBQWlCLFNBQVEsZ0JBQVU7SUFXOUMsaUJBQWlCO1FBQ2YsS0FBSyxDQUFDLGlCQUFpQixFQUFFLENBQUE7UUFDekIsSUFBSSxDQUFDLFlBQVksQ0FBQyxNQUFNLEVBQUUsTUFBTSxDQUFDLENBQUE7SUFDbkMsQ0FBQztJQUVELE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzBCQUNXLElBQUksQ0FBQyxnQkFBZ0I7S0FDMUMsQ0FBQTtJQUNILENBQUM7SUFFTyxnQkFBZ0I7UUFDdEIsSUFBSSxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsWUFBWSxDQUFDLE1BQU0sRUFBRSxVQUFVLENBQUMsQ0FBQyxDQUFBO0lBQ25FLENBQUM7O0FBdkJNLHVCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7R0FPbEIsQ0FBQTtBQUN5QztJQUF6QyxJQUFBLHFDQUFxQixFQUFDLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDOytDQUE4QjtBQVQ1RCxnQkFBZ0I7SUFENUIsSUFBQSw2QkFBYSxFQUFDLHVCQUF1QixDQUFDO0dBQzFCLGdCQUFnQixDQXlCNUI7QUF6QlksNENBQWdCIn0=